// extracted by mini-css-extract-plugin
export default {"_tabsHeading":"TabsComponent__tabsHeading__Sx6z0","_initialTab":"TabsComponent__initialTab__gsYI2","_active":"TabsComponent__active__YoOz-"};